export default __webpack_public_path__ + "static/media/password.540ced60.svg";